import React, { useEffect, useState, useCallback, useRef } from "react";
import cn from "classnames";
import styles from "./ViewFirmware.module.scss";
import Master from "screen/Master";
import { NotificationManager } from "react-notifications";

var id = undefined;
var view = undefined;

function firmwareView(props) {
  view = props?.match?.params?.view;
  id = props?.match?.params?.id;

  const firmwareData1 = props.location.state.firmwareData;
  const selectedFirmware = firmwareData1.find(item => item.firmwareID === id) || {};

  const handleDelete = () => {
    NotificationManager.success('Firmware Downloaded successfully');
  };

  return (
    <>
      <div className={cn(styles.flex_item)}>
        <h2>Firmware OTA</h2>
        <h3>&gt;</h3>
        <h3>View Firmware Details</h3>
      </div>
      <div className={cn(styles.flex_item1)}>
        <h1>View Firmware Details</h1>
        <div className={cn(styles.Delete_block)}>
          <img
            src={require("assets/DeleteIcon.svg").default}
            alt="Rectangle 16663"
          />
          <p>Delete Firmware</p>
        </div>
      </div>
      <div className={cn(styles.block1)}>
        <div className={cn(styles.block1_layout)}>
          <div className={cn(styles.block1_text)}>
            <h1>Firmware Id</h1>
            <h2>{selectedFirmware.firmwareID}</h2>
          </div>
          <div className={cn(styles.block1_text)}>
            <h1>Model No</h1>
            <h2>{selectedFirmware.model}</h2>
          </div>
        </div>
        <div className={cn(styles.block1_layout)}>
          <div className={cn(styles.block1_text)}>
            <h1>Released On</h1>
            <h2>{selectedFirmware.releasedOn}</h2>
          </div>
          <div className={cn(styles.block1_text)}>
            <h1>Size</h1>
            <h2>{selectedFirmware.size}</h2>
          </div>
        </div>
        <div className={cn(styles.block1_layout)}>
          <div className={cn(styles.block1_text)}>
            <h1>Firmware Version</h1>
            <h2>{selectedFirmware.version}</h2>
          </div>
          <div className={cn(styles.block1_text)}>
            <h1>Release Note</h1>
            <h2>XXXXXXX</h2>
          </div>
        </div>
        <div className={cn(styles.block1_layout)}>
          <div className={cn(styles.block1_text)}>
            <h1>Manufacturer</h1>
            <h2>{selectedFirmware.firmwareID}</h2>
          </div>
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <div className={cn(styles.flex2_spacer3)} />
        <div>
          <button className={cn(styles.Download_button)} onClick={handleDelete}>
            <img
              style={{
                paddingRight: "5px",
              }}
              src={require("assets/ic_download.svg").default}
              alt="Rectangle 16663"
              
            />
            Download Firmware
          </button>
        </div>
      </div>
    </>
  );
}

export default function AddFirmware(props) {
  return (
    <>
      <Master opts={props} screen={firmwareView} showStatus={false} />
    </>
  );
}

AddFirmware.inStorybook = true;
